var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71668 3.00091L1.71347 5.426V17.4251C1.71347 19.4755 3.37563 21.1376 5.426 21.1376L8.83564 21.1386C9.16442 21.7681 9.58081 22.3446 10.0686 22.8518L5.426 22.8511C2.4293 22.8511 0 20.4218 0 17.4251V5.426C0 4.30572 0.71674 3.35284 1.71668 3.00091ZM15.7068 0C17.1263 0 18.2771 1.15072 18.2771 2.57021L18.2777 10.8502C17.3984 10.4834 16.4335 10.2808 15.4213 10.2808C11.3205 10.2808 7.99621 13.6052 7.99621 17.7059C7.99621 18.5032 8.12188 19.2711 8.35448 19.991L5.426 19.9905C4.00651 19.9905 2.85579 18.8398 2.85579 17.4203V2.57021C2.85579 1.15072 4.00651 0 5.426 0H15.7068Z",
    fill: "#2A2F34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41309 17.8486C9.41309 14.4513 12.1671 11.6973 15.5645 11.6973C18.9617 11.6973 21.7158 14.4513 21.7158 17.8486C21.7158 21.2459 18.9617 24 15.5645 24C12.1671 24 9.41309 21.2459 9.41309 17.8486ZM16.1796 15.3881C16.1796 15.0484 15.9042 14.773 15.5645 14.773C15.2247 14.773 14.9493 15.0484 14.9493 15.3881V18.8241L13.5389 17.4137C13.2986 17.1735 12.9092 17.1735 12.6689 17.4137C12.4287 17.6539 12.4287 18.0434 12.6689 18.2836L15.1295 20.7441C15.3697 20.9844 15.7592 20.9844 15.9994 20.7441L18.46 18.2836C18.7002 18.0434 18.7002 17.6539 18.46 17.4137C18.2198 17.1735 17.8303 17.1735 17.59 17.4137L16.1796 18.8241V15.3881Z",
    fill: "#2A2F34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyMove);
export default __webpack_public_path__ + "static/media/copy-move.9b8b8ab2bc99f90f500bdcd7213642b2.svg";
export { ForwardRef as ReactComponent };